/**
 * Handles back to top button
 * @module backToTop
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'backToTop';
export const DEFAULTS = {

};

// Scroll to top function
const scrollToTop = () => {
  $('html, body').animate({ scrollTop: 0 }, 'slow');
};

const backToTopEventHandlers = ($el) => {
  // Check if back to top button exist
  if ($el.length) {
    // Add click event to scrop top
    $el.on('click', () => {
      scrollToTop();
      if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
        window.PAGE_TRACK_A_MODULE.insertEventTrack('back_to_top_btn', 'user_click');
      }
      document.querySelector('body').focus();
    });

    // Check window position
    $(window).scroll(function handleScroll() {
      const scrollPos = $(this).scrollTop();
      if (scrollPos > 100) {
        $el.fadeIn();
      } else {
        $el.fadeOut();
      }
    });
  }
  // ---------------------------
  // Fixed Corner Module
  // ---------------------------

  const fixedModule = $('.fixed-corner');
  const fixedOffClass = 'fixed-corner--off';

  $(window).on('scroll resize', function handleFixCorner() {
    const $window = $(this);
    const docHeight = $(document).height();
    const windowHeight = $window.height();
    const scrollPosY = $window.scrollTop();
    const pagination = $('.pagination__wrapper');
    let footerHeight = $('#site-footer').outerHeight(true);
    if (pagination.length > 0) {
      const paginationHeight = pagination.height() + 16 + 44;
      footerHeight += paginationHeight;
    }
    if ($('#mock-page-options').length) {
      const mock = $('#mock-page-options').parent().outerHeight(true);
      footerHeight += mock;
    }
    const footerScrollPosY = docHeight - footerHeight - windowHeight;

    if (scrollPosY >= footerScrollPosY) {
      fixedModule.addClass(fixedOffClass);
      if (pagination.length === 0) {
        fixedModule.addClass('fixed-corner--bottom');
      }
    } else {
      fixedModule.removeClass(fixedOffClass);
      if (pagination.length === 0) {
        fixedModule.removeClass('fixed-corner--bottom');
      }
    }
  });
};

export default function backToTop() {
  const $el = $('.js-back-to-top');
  backToTopEventHandlers($el);
}

registerJQueryPlugin(PLUGIN_NAME, backToTop);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/back-to-top.js